import CarbonNeutralityDeleteRow from './CarbonNeutralityDeleteRow';
import CarbonNeutralityEditRow from './CarbonNeutralityEditRow';

type CarbonActionsProps = { rowId: number | string };
const CarbonActions = ({ rowId }: CarbonActionsProps) => {
  return (
    <>
      <CarbonNeutralityEditRow rowId={rowId} />
      <CarbonNeutralityDeleteRow rowId={rowId} />
    </>
  );
};

export default CarbonActions;
